
import { RowTriple24Regular, RowTriple24Filled, bundleIcon } from "@fluentui/react-icons";

export const AttributeIcon = bundleIcon(RowTriple24Filled, RowTriple24Regular);